(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('weekdayMultipleFilter', ['AgendaFilterBroadcast', '$filter', WeekdayMultipleFilterFn]);

    // filter directive for multiple weekday selection
    function WeekdayMultipleFilterFn(AgendaFilterBroadcast, $filter) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/weekday-multiple-filter.template.html',
            scope: {
                weekdays: '=',
                paginationService: '='
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // listener for broadcast
            var listener = null;
            var listenerCalc = null;
            var listenerClear = null;

            // number of set filter
            scope.numFilters = 0;

            //activate directive
            activate();

            // filter list
            scope.filter = function ($event, day) {
                $event.stopPropagation();
                //reset
                scope.numFilters = 0;

                // day change
                if (day !== null) {
                    day.vmSelected = !day.vmSelected;
                }

                // refresh view
                refresh();
            };

            // on destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }

                if (listenerCalc) {
                    listenerCalc();
                    listenerCalc = null;
                }

                if (listenerClear) {
                    listenerClear();
                    listenerClear = null;
                }
            });

            // calc numbers of appointments for weekdays
            function calculate() {
                clear();

                // number of appointments in defined weekdays
                for (var j = 0; j < scope.paginationService.data.items.length; j++) {
                    var appointmentsPerDay = scope.paginationService.data.items[j].appointmentsPerDay;
                    // convert object (dictionary with list as value) to array
                    for (var date in appointmentsPerDay) {
                        if (appointmentsPerDay.hasOwnProperty(date)) {
                            var appointmentList = appointmentsPerDay[date];
                            for (var m = 0; m < appointmentList.length; m++) {
                                var state = $filter('filter')(scope.weekdays, { 'value': appointmentList[m].weekday }, true)[0];
                                if (state) {
                                    state.vmNumber++;
                                } //if
                            }
                        } //if
                    } // for
                } //for
            } // calculate

            // refresh view
            function refresh() {
                // number of selected weekdays
                scope.numFilters = 0;
                for (var i = 0; i < scope.weekdays.length; i++) {
                    if (scope.weekdays[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // clear badge counts
            function clear() {
                //reset badge numbers
                for (var i = 0; i < scope.weekdays.length; i++) {
                    scope.weekdays[i].vmNumber = 0;
                } // for
            }

            function listen() {
                //check for doing a refresh
                listener = scope.$on(AgendaFilterBroadcast.WeekdayRefresh, function () {
                    refresh();
                });

                listenerCalc = scope.$on(AgendaFilterBroadcast.WeekdayCalculate, function () {
                    calculate();
                });

                listenerClear = scope.$on(AgendaFilterBroadcast.WeekdayClear, function () {
                    clear();
                });
            } // listen

            // init work
            function activate() {
                // calculate badge count
                calculate();
                // refresh view
                refresh();
                // listen to changes
                listen();
            } //activate
        } // link
    }
})();